import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M20 4v16","key":"svg-0"}],["path",{"d":"M4 6h12","key":"svg-1"}],["path",{"d":"M10 12h6","key":"svg-2"}],["path",{"d":"M6 18h10","key":"svg-3"}]]

const IconAlignRight2 = createReactComponent('outline', 'align-right-2', 'AlignRight2', __iconNode);

export default IconAlignRight2;